export enum SaveFeatures {
  AudienceName = 1 << 0,
  Client = 1 << 1,
  GiftAmount = 1 << 2,
  Order = 1 << 3,
  OrderType = 1 << 4,
  Mailcode = 1 << 5,
  Tags = 1 << 6,
  Description = 1 << 7,
  Selects = 1 << 8,
  Audience = OrderType | AudienceName | Client | GiftAmount | Order,
  AudiencePreBuilt = OrderType | AudienceName | Client | Order,
  AudienceMasterFile = OrderType | AudienceName | Client,
  Shop = Audience | Mailcode | Tags | Description | Selects,
  ShopPreBuilt = OrderType | AudienceName | Client | Order | Tags | Description | Selects,
  ShopMasterFile = ShopPreBuilt & ~Order,
}
